import React, { useEffect, useState } from 'react';
import { getAllUserMetrics } from '../../../services/apiService';
import { toast } from 'react-toastify';

const METRIC_CARDS = [
  { key: 'totalUsers', label: 'Total Learners' },
  { key: 'enrolledUsers', label: 'Enrolled Users' },
  { key: 'freeUsers', label: 'Free Users' },
  { key: 'completedUsers', label: 'Completed Users' },
  { key: 'proXUsers', label: 'ProX Users' },
  { key: 'sspUsers', label: 'SSP Users' },
];

const cardStyle = {
  flex: '1 1 0',
  minWidth: 130,
  padding: '14px 18px',
  backgroundColor: 'var(--card-background, #fff)',
  border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
  borderRadius: 12,
  boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
};

const labelStyle = {
  fontSize: 11,
  fontWeight: 500,
  color: 'var(--text-secondary, #6B7280)',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  lineHeight: 1.2,
};

const valueStyle = {
  fontSize: 20,
  fontWeight: 700,
  color: 'var(--text-primary, #111827)',
  lineHeight: 1.3,
};

export default function Metrics() {
  const [userMetrics, setUserMetrics] = useState(null);

  const getUserMetrics = async () => {
    try {
      const response = await getAllUserMetrics();
      setUserMetrics(response);
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch metrics');
    }
  };

  useEffect(() => {
    getUserMetrics();
  }, []);

  if (!userMetrics) return null;

  return (
    <div
      style={{
        display: 'flex',
        gap: 12,
        padding: '16px 20px',
        overflowX: 'auto',
      }}
    >
      {METRIC_CARDS.map((m) => (
        <div key={m.key} style={cardStyle}>
          <span style={labelStyle}>{m.label}</span>
          <span style={valueStyle}>
            {userMetrics[m.key]?.toLocaleString() ?? '—'}
          </span>
        </div>
      ))}
    </div>
  );
}
